module.exports = __webpack_public_path__ + "img/point_body_w.a1e81a4d.svg";